import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Real.css";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import {
  submitEnquiryForm,
  resetEnquiryFormState,
} from "../store/slices/enquiryFormSlice";

const statss = [
  { label: "Years of Excellence", value: "10+" },
  { label: "Projects Completed", value: "12+" },
  { label: "Mn. Sq. Ft. Delivered", value: "20+" },
  { label: "Ongoing Projects", value: "25+" },
];

const tenantsServices = [
  { icon: "📄", title: "Online Rent Agreement" },
  { icon: "🏠", title: "Rent Receipts" },
  { icon: "🏢", title: "Property Management" },
];

// Note: serviceTabs is imported but not used - consider removing if not needed
const serviceTabs = [
  { id: "buyers", label: "For Buyers / Owners", content: tenantsServices },
  { id: "tenants", label: "For Tenants", content: tenantsServices },
  { id: "agents", label: "For Agents", content: tenantsServices },
  { id: "builders", label: "For Builders & Banks", content: tenantsServices },
];

const allProjectsData = [
  {
    id: 1,
    name: "Rajhans Feriado",
    location: "Surat, Gujarat",
    price: "₹ 4.50 Cr+",
    city: "Surat",
    type: "Weekend Villas",
    bedrooms: "3, 4 & 5 BHK",
    category: "Leisure",
    img: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=800",
  },
  {
    id: 2,
    name: "Rajhans Silvana",
    location: "Surat, Gujarat",
    price: "₹ 2.80 Cr+",
    city: "Surat",
    type: "Grandeur Lifestyle",
    bedrooms: "4 BHK",
    category: "Residential",
    img: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=800",
  },
  {
    id: 3,
    name: "Rajhans Evana",
    location: "Khopoli, Maharashtra",
    price: "₹ 3.20 Cr+",
    city: "Khopoli",
    type: "Luxury Villas",
    bedrooms: "4, 5 BHK",
    category: "Leisure",
    img: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=800",
  },
  {
    id: 5,
    name: "Imperial Heights",
    location: "Surat, Gujarat",
    price: "₹ 1.90 Cr",
    city: "Surat",
    type: "Apartment",
    bedrooms: "2-3 BHK",
    category: "Residential",
    img: "https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=800",
  },
  {
    id: 6,
    name: "The Waterfront",
    location: "Surat, Gujarat",
    price: "₹ 7.20 Cr",
    city: "Surat",
    type: "Penthouse",
    bedrooms: "5 BHK",
    category: "Leisure",
    img: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?q=80&w=800",
  },
  {
    id: 7,
    name: "Business Hub",
    location: "Surat, Gujarat",
    price: "₹ 85.00 Lac+",
    city: "Surat",
    type: "Office Space",
    bedrooms: "N/A",
    category: "Commercial",
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800",
  },
  {
    id: 8,
    name: "Rajhans Belliza",
    location: "Surat, Gujarat",
    price: "₹ 1.10 Cr+",
    city: "Surat",
    type: "Studio",
    bedrooms: "1 BHK",
    category: "Leisure",
    img: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=800",
  },
  {
    id: 9,
    name: "Sky Garden",
    location: "Bangalore, KA",
    price: "₹ 3.40 Cr",
    city: "Bangalore",
    type: "Apartment",
    bedrooms: "3-4 BHK",
    category: "Residential",
    img: "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?q=80&w=800",
  },
  {
    id: 10,
    name: "The Legacy",
    location: "Gurgaon, HR",
    price: "₹ 6.80 Cr",
    city: "Gurgaon",
    type: "Villa",
    bedrooms: "4 BHK",
    category: "Residential",
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800",
  },
  {
    id: 12,
    name: "Green Meadows",
    location: "Pune, MH",
    price: "₹ 1.45 Cr",
    city: "Pune",
    type: "Apartment",
    bedrooms: "2 BHK",
    category: "Leisure",
    img: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=800",
  },
  {
    id: 13,
    name: "Rajhans Elita",
    location: "Surat, Gujarat",
    price: "₹ 3.90 Cr",
    city: "Surat",
    type: "Apartment",
    bedrooms: "4 BHK",
    category: "Residential",
    img: "https://images.unsplash.com/photo-1567496898669-ee935f5f647a?q=80&w=800",
  },
  {
    id: 14,
    name: "Corporate Plaza",
    location: "Mumbai, MH",
    price: "₹ 12.00 Cr",
    city: "Mumbai",
    type: "Retail Hub",
    bedrooms: "N/A",
    category: "Commercial",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800",
  },
  {
    id: 15,
    name: "Weekend Retreat",
    location: "Khopoli, Maharashtra",
    price: "₹ 2.20 Cr",
    city: "Khopoli",
    type: "Cottage",
    bedrooms: "2 BHK",
    category: "Leisure",
    img: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=800",
  },
];

const servicesData = [
  {
    id: "01",
    title: "Buy",
    tagline: "Own Your Future Home",
    description:
      "Explore an exclusive portfolio of premium residential properties and high-yield commercial plots. Our curated listings ensure you find a space that matches your lifestyle and investment goals.",
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "02",
    title: "Rent",
    tagline: "Lease Premium Spaces",
    description:
      "From luxury penthouses to strategic corporate offices, our rental division connects you with top-tier properties across the city's most sought-after pin codes.",
    img: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "03",
    title: "Sell",
    tagline: "Maximum Value, Zero Stress",
    description:
      "Leverage our massive network and premium branding to sell your property at the best market price. We handle the aesthetics, marketing, and legalities while you relax.",
    img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "04",
    title: "List Property",
    tagline: "Join Our Premium Network",
    description:
      "Listing with Krishna Finconcept means instant visibility to thousands of verified buyers. Use our advanced dashboard to track leads and manage your property portfolio.",
    img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
  },
];

export default function RealState() {
  const [activeCity, setActiveCity] = useState("All");
  const [activeTab, setActiveTab] = useState("Buy");
  const [activeServiceItem, setActiveServiceItem] = useState(servicesData[0]);
  const scrollContainerRef = useRef(null);

  const tabs = ["Buy", "Rent", "Sell"];
  const cities = [
    "All",
    "Mumbai",
    "Bangalore",
    "Delhi",
    "Pune",
    "Chennai",
    "Kolkata",
    "Surat",
    "Gurgaon",
  ];

  const allProjects = allProjectsData.map((p) => ({
    ...p,
    category:
      p.category === "Leisure"
        ? "Buy"
        : p.category === "Commercial"
          ? "Sell"
          : "Buy",
    city: p.city,
  }));

  const filteredProjects = allProjects.filter((project) => {
    const matchesTab = project.category === activeTab;
    const matchesCity = activeCity === "All" || project.city === activeCity;
    return matchesTab && matchesCity;
  });

  const scrollLeft = () =>
    scrollContainerRef.current?.scrollBy({ left: -380, behavior: "smooth" });
  const scrollRight = () =>
    scrollContainerRef.current?.scrollBy({ left: 380, behavior: "smooth" });

  const dispatch = useDispatch();
  const recaptchaRef = useRef();
  const { loading, error, success } = useSelector((state) => state.enquiryForm);

  const [captchaValue, setCaptchaValue] = useState(null);
  const [consent, setConsent] = useState(false);
  const [errors, setErrors] = useState({});

  // Real Estate Specific Fields - Using require_service instead of purpose
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    mobile: "",
    require_service: "Buy", // Changed from purpose to require_service
    property_category: "Residential",
    bhk_config: "",
    budget_range: "",
    preferred_location: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "mobile") {
      newValue = value.replace(/\D/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.fullname.trim()) {
      newErrors.fullname = "Full name required";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (!/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile must be 10 digits";
    }

    if (!formData.bhk_config) {
      newErrors.bhk_config = "Select BHK preference";
    }

    if (!formData.preferred_location.trim()) {
      newErrors.preferred_location = "Preferred location required";
    }

    if (!consent) {
      newErrors.consent = "Accept privacy policy";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaValue) {
      toast.error("Please verify that you are human");
      return;
    }

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      Object.values(validationErrors).forEach((err) => toast.error(err));
      return;
    }

    // Submit the form data with require_service field
    dispatch(submitEnquiryForm(formData));
  };

  // Fixed useEffect with proper dependencies
  useEffect(() => {
    if (success) {
      toast.success("Property enquiry submitted!");
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setCaptchaValue(null);

      setFormData({
        fullname: "",
        email: "",
        mobile: "",
        require_service: "Buy", // Reset to default
        property_category: "Residential",
        bhk_config: "",
        budget_range: "",
        preferred_location: "",
        description: "",
      });

      setConsent(false);
      setErrors({});
      dispatch(resetEnquiryFormState());
    }

    if (error) {
      toast.error(error);
      dispatch(resetEnquiryFormState());
    }
  }, [success, error, dispatch]);

  return (
    <>
      {/* HERO SECTION */}
      <section className="kf-hero-v2">
        <div className="kf-hero-v2__shape kf-hero-v2__shape-1"></div>
        <div className="kf-hero-v2__shape kf-hero-v2__shape-2"></div>
        <div className="kf-hero-v2__shape kf-hero-v2__shape-3"></div>
        <div className="kf-hero-v2__pattern"></div>
        <div className="kf-hero-v2__container">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="kf-hero-v2__content"
          >
            <div className="kf-hero-v2__badge">
              <span className="kf-hero-v2__badge-dot"></span>Discover Your
              Legacy
            </div>
            <h1 className="kf-hero-v2__title">
              The Art of <br /> Finding{" "}
              <span className="gradient-text">Perfect Spaces</span>
            </h1>
            <p className="kf-hero-v2__subtitle">
              Krishna Finconcept bridges the gap between vision and reality.
              Curated properties for those who demand excellence.
            </p>
            <div className="kf-hero-v2__stats-row">
              {statss.map((stat, idx) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  className="kf-hero-v2__stat-item"
                >
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <div className="loan-form-card">
            <h3 className="loan-form-title">Property Enquiry</h3>

            <form className="loan-form-wrapper" onSubmit={handleSubmit}>
              {/* Purpose Toggle (Buy/Rent/Sell) - Now using require_service */}
              <div
                className="purpose-toggle"
                style={{ marginBottom: "20px", display: "flex", gap: "10px" }}
              >
                {["Buy", "Rent", "Sell"].map((type) => (
                  <button
                    key={type}
                    type="button"
                    className={
                      formData.require_service === type ? "active" : ""
                    }
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      background:
                        formData.require_service === type ? "#4f46e5" : "#fff",
                      color:
                        formData.require_service === type ? "#fff" : "#333",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setFormData({ ...formData, require_service: type })
                    }
                  >
                    {type}
                  </button>
                ))}
              </div>

              {/* Row 1: Basic Info */}
              <div className="loan-form-row">
                <div className="loan-input-box">
                  <input
                    type="text"
                    name="fullname"
                    placeholder=" "
                    value={formData.fullname}
                    onChange={handleChange}
                  />
                  <label>Full Name</label>
                  {errors.fullname && (
                    <span className="loan-error">{errors.fullname}</span>
                  )}
                </div>

                <div className="loan-input-box">
                  <input
                    type="tel"
                    name="mobile"
                    maxLength="10"
                    placeholder=" "
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                  <label>Mobile Number</label>
                  {errors.mobile && (
                    <span className="loan-error">{errors.mobile}</span>
                  )}
                </div>
              </div>

              {/* Row 2: Contact & Category */}
              <div className="loan-form-row">
                <div className="loan-input-box">
                  <input
                    type="email"
                    name="email"
                    placeholder=" "
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <label>Email Address</label>
                  {errors.email && (
                    <span className="loan-error">{errors.email}</span>
                  )}
                </div>

                <div className="loan-input-box">
                  <select
                    name="property_category"
                    value={formData.property_category}
                    onChange={handleChange}
                  >
                    <option value="Residential"></option>
                    <option value="Residential">Residential</option>
                    <option value="Commercial">Commercial</option>
                    <option value="Plot/Land">Plot / Land</option>
                    <option value="Villa">Weekend Villa</option>
                  </select>
                  <label>Category</label>
                </div>
              </div>

              {/* Row 3: Preferences */}
              <div className="loan-form-row">
                <div className="loan-input-box">
                  <select
                    name="bhk_config"
                    value={formData.bhk_config}
                    onChange={handleChange}
                  >
                    <option value=""></option>
                    <option value="1BHK">1 BHK</option>
                    <option value="2BHK">2 BHK</option>
                    <option value="3BHK">3 BHK</option>
                    <option value="4BHK">4 BHK</option>
                    <option value="5BHK+">5 BHK+</option>
                    <option value="Office">Office Space</option>
                  </select>
                  <label>Configuration</label>
                  {errors.bhk_config && (
                    <span className="loan-error">{errors.bhk_config}</span>
                  )}
                </div>

                <div className="loan-input-box">
                  <input
                    type="text"
                    name="preferred_location"
                    placeholder=" "
                    value={formData.preferred_location}
                    onChange={handleChange}
                  />
                  <label>Preferred Location (e.g. Surat)</label>
                  {errors.preferred_location && (
                    <span className="loan-error">
                      {errors.preferred_location}
                    </span>
                  )}
                </div>
              </div>

              {/* Description */}
              <div className="loan-form-row">
                <div className="loan-input-box full-width">
                  <textarea
                    name="description"
                    rows="3"
                    placeholder=" "
                    value={formData.description}
                    onChange={handleChange}
                  ></textarea>
                  <label>Any Specific Requirements?</label>
                </div>
              </div>

              {/* Consent */}
              <div className="li-terms-group">
                <input
                  type="checkbox"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                />
                <label>
                  I agree to receive property updates from{" "}
                  <strong>Krishana Finconcept</strong> and accept the{" "}
                  <a href="/terms" target="_blank">
                    Terms & Conditions
                  </a>
                </label>
              </div>
              {errors.consent && (
                <span className="loan-error">{errors.consent}</span>
              )}

              {/* ReCAPTCHA */}
              <div className="recaptcha-box">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA}
                  onChange={(val) => setCaptchaValue(val)}
                />
              </div>

              <button
                type="submit"
                className="loan-submit-btn"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Send Request"}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* PROJECTS SECTION with HORIZONTAL SCROLL */}
      <section className="ps-wrapper">
        <div className="ps-container">
          <div className="ps-header">
            <span className="ps-badge">Our Projects</span>
            <div className="ps-tabs-row">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`ps-tab-btn ${activeTab === tab ? "ps-active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="ps-city-filters">
              {cities.map((city) => (
                <button
                  key={city}
                  className={`ps-city-btn ${activeCity === city ? "ps-city-active" : ""}`}
                  onClick={() => setActiveCity(city)}
                >
                  {city}
                </button>
              ))}
            </div>
          </div>
          <div className="ps-carousel-container">
            <button className="ps-nav-arrow ps-nav-left" onClick={scrollLeft}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M15 18L9 12L15 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="ps-scroll-container" ref={scrollContainerRef}>
              <div className="ps-scroll-track">
                <AnimatePresence mode="popLayout">
                  {filteredProjects.map((project) => (
                    <motion.div
                      layout
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.9 }}
                      transition={{ duration: 0.3 }}
                      key={project.id}
                      className="ps-card"
                    >
                      <div className="ps-card-image">
                        <img src={project.img} alt={project.name} />
                        <span className="ps-card-tag">{project.category}</span>
                      </div>
                      <div className="ps-card-content">
                        <h3 className="ps-card-title">{project.name}</h3>
                        <p className="ps-card-type">
                          {project.bedrooms} {project.type}
                        </p>
                        <p className="ps-card-location">
                          <span className="ps-location-icon">📍</span>{" "}
                          {project.location}
                        </p>
                        <div className="ps-card-footer">
                          <span className="ps-card-price">{project.price}</span>
                          <button className="ps-card-btn">View Details</button>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </div>
            </div>
            <button className="ps-nav-arrow ps-nav-right" onClick={scrollRight}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 18L15 12L9 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
          {filteredProjects.length === 0 && (
            <div className="ps-no-results">
              <p>
                No properties found in {activeCity} for {activeTab}
              </p>
            </div>
          )}
        </div>
      </section>

      {/* DYNAMIC SERVICE TABS SECTION */}
      <section className="kf-nav-section">
        <div className="kf-nav-header">
          <span className="kf-gold-sub">Our Expertise</span>
          <h2>Redefining the Property Journey</h2>
        </div>
        <div className="kf-nav-container">
          <div className="kf-nav-tabs">
            {servicesData.map((item) => (
              <div
                key={item.id}
                className={`kf-nav-item ${activeServiceItem.id === item.id ? "active" : ""}`}
                onMouseEnter={() => setActiveServiceItem(item)}
                onClick={() => setActiveServiceItem(item)}
              >
                <span className="item-num">{item.id}.</span>
                <span className="item-title">{item.title}</span>
              </div>
            ))}
          </div>
          <AnimatePresence mode="wait">
            <motion.div
              key={activeServiceItem.id}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              className="kf-nav-content"
            >
              <div className="kf-nav-image">
                <img
                  src={activeServiceItem.img}
                  alt={activeServiceItem.title}
                />
              </div>
              <div className="kf-nav-text">
                <h3>{activeServiceItem.title}</h3>
                <p className="tagline">{activeServiceItem.tagline}</p>
                <p className="desc">{activeServiceItem.description}</p>
                <button className="kf-gold-link">Explore Service —</button>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>
      {/* SIGNATURE / BRAND SECTION */}
      <section className="kf-signature-wrapper">
        <div className="kf-signature-bg-text">ELITE</div>
        <div className="kf-signature-container">
          <div className="kf-signature-left">
            <div className="kf-vertical-tag">ESTABLISHED 2026</div>
            <div className="kf-main-brand-content">
              <h4 className="kf-sub-heading">Modern Real Estate Solutions</h4>
              <h2 className="kf-main-heading">
                Krishna <br />
                <span className="kf-accent-text">Finconcept</span>
              </h2>
              <p className="kf-brand-statement">
                We don't just find spaces; we curate lifestyles. From high-yield
                investments to soulful homes, our boutique approach covers{" "}
                <strong>Listing, Buying, Selling,</strong> and{" "}
                <strong>Leasing</strong>.
              </p>
              <div className="kf-signature-stats">
                <div className="kf-stat-item">
                  <strong>500+</strong> <span>Properties</span>
                </div>
                <div className="kf-stat-item">
                  <strong>15+</strong> <span>City Hubs</span>
                </div>
              </div>
            </div>
          </div>
          <div className="kf-signature-right">
            <div className="kf-tile-grid">
              <div className="kf-glass-tile tile-featured">
                <div className="tile-icon">✦</div>
                <h3>List Property</h3>
                <p>Market your assets to our exclusive premium network.</p>
                <a href="#list" className="tile-link">
                  Get Started →
                </a>
              </div>
              <div className="kf-glass-tile">
                <div className="tile-icon">◈</div>
                <h3>Buy</h3>
                <p>Find luxury residential & commercial plots.</p>
              </div>
              <div className="kf-glass-tile">
                <div className="tile-icon">⟡</div>
                <h3>Rent</h3>
                <p>Curated leasing options in top-tier locations.</p>
              </div>
              <div className="kf-glass-tile">
                <div className="tile-icon">△</div>
                <h3>Sell</h3>
                <p>Seamless exit strategies with maximum ROI.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
